module.exports = __webpack_public_path__ + "static/img/login-logo.8cf0f015.svg";